import React from 'react';
import PropTypes from 'prop-types';

function LanguageSwitch({ language, onChange }) {
  return (
    <div className="App-language-switch">
      <button
        type="button"
        onClick={() => onChange('en')}
        className={language === 'en' ? 'active' : ''}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="App-language-separator">|</span>
      <button
        type="button"
        onClick={() => onChange('pt-BR')}
        className={language === 'pt-BR' ? 'active' : ''}
        aria-label="Mudar para Português (Brasil)"
      >
        PT-BR
      </button>
    </div>
  );
}

LanguageSwitch.propTypes = {
  language: PropTypes.oneOf(['en', 'pt-BR']).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default LanguageSwitch;
